import { MapWithDefault, equalSets, equalArrays, comparator } from './utils';
import Vue from 'vue'
import Vuex from 'vuex'
import router from './router';

export type FieldType = 'string' | 'number' | 'integer' | 'boolean' | 'array'

Vue.use(Vuex)

// type AnnotationEntry {
//   name?: string;
//   age?: number;
// }

export default new Vuex.Store({
  state: {
    entries: new Array<Record<string, any>>(),
    keyField: '',
    selectedKeys: new Set<string>(),
    filter: [],
    focusedEntry: null
  },
  getters: {
    entriesCount: (state, getters) => (state.entries.length),
    //selectedEntries: (state, getters) => (state.entries.filter( (entry) => state.selectedKeys.includes(entry[state.keyField]))),
    //selectedEntriesCount: (state, getters) => (getters.selectedEntries.length)
    selectedKeysCount: (state, getters) => (state.selectedKeys.size),
    fieldTypes: (state, getters) => {
      // check field types
      const fieldTypes = new Map<string, FieldType>()
      for (const entry of state.entries) {
        for (const [field, value] of Object.entries(entry)) {
          const fieldType = Array.isArray(value) ? 'array' : (typeof value) as FieldType
          if (fieldTypes.has(field) && fieldType !== fieldTypes.get(field)) {
            console.error(`type mismatch in field ${field}: got ${value} as ${fieldType}, expected ${fieldTypes.get(field)}`)
          } else {
            fieldTypes.set(field, fieldType)
          }
        }
      }
      return fieldTypes
    },
    fieldLevels: (state, getters) => {
      // for all fields of type a string or array, extract the unique levels
      const fieldLevelSets = new MapWithDefault<string, Set<string>>( () => (new Set<string>()) )
      for (const entry of state.entries) {
        for (const [field, value] of Object.entries(entry)) {
          const fieldType = getters.fieldTypes.get(field)
          if (fieldType === 'array') {
            for (const v of (value as Array<string>)) {
              if (v != null && v.length > 0) {
                fieldLevelSets.get(field).add(v)
              }
            }
          } else if (fieldType === 'string' && value.length > 0) {
              fieldLevelSets.get(field).add(value)
          } 
        }
      }
      // sort and return the levels
      const fieldLevels = new Map<string, Array<string>>()
      for (const [field, levels] of fieldLevelSets.entries()) {
        fieldLevels.set(field, Array.from(levels).sort(comparator))
      }
      return fieldLevels
    },
  },
  mutations: {
    setKeyField (state, keyField: string) {
      console.debug(`store: setting keyField to '${keyField}'`)
      state.keyField = keyField
    },
    setEntries (state, entries: Record<string, any>[]) {
      console.debug(`store: setting ${entries.length} entries`)
      state.entries = entries
    },
    setFilter (state, filter: []) {
      console.debug(`store: setting filter to ${filter}`)
      state.filter = filter
    },
    setFocusedEntry (state, focusedEntry) {
      console.debug(`store: setting focusedEntry to ${focusedEntry?.[state.keyField]}`)
      state.focusedEntry = focusedEntry
    },
    selectEntries (state, keys: Set<string>) {
      console.debug(`store: selecting ${keys.size} keys`)
      state.selectedKeys = keys
      // for (let i=0; i<state.entries.length; i++) {
      //   const elem = state.entries[i]
      //   if (elem._selected && elem[fieldName]!=fieldValue) {
      //     Vue.set(state.entries, i, {...elem, _selected: 0})
      //   } else if (elem[fieldName]==fieldValue && !elem._selected) {
      //     Vue.set(state.entries, i, {...elem, _selected: 1})
      //   }
      // }
    },
  },
  actions: {
    async loadData ({ commit, state }, {url, keyField}) {
      // read in the data
      const data = await (await fetch(url)).json()
      // for (const elem of data) {
      //   elem._1 = 1
      //   elem._selected = 1 // Math.random() > 0.5
      //   elem['Subcellular_localization'] = new Set(elem['Subcellular_localization'].split('; '))
      // }
      commit('setKeyField', keyField)
      commit('setEntries', data)
    },
    selectEntries ({commit, state}, {keys}) {
      console.log('checking selected keys', Date.now())
      if (equalSets(keys, state.selectedKeys)) {
        console.log('no update needed', Date.now())
      } else {
        commit('selectEntries', keys)
      }
      // if (selectedIndices) {
      //   commit('selectEntries', selectedIndices)
      // } else {
      //   commit('selectEntries', seq(state.entries.length))
      // }
    },
    setFilter ({commit, state}, {filter, updateRoute = true}) {
      commit('setFilter', filter)
      if (updateRoute) {
        router.push({ name: 'spa', params: { filter: filter ? JSON.stringify(filter) : ''} })
      }
    },
    setFocusedEntry ({commit, state}, {key}) {
      const entry = state.entries.find( (entry) => (entry[state.keyField] == key) )
      commit('setFocusedEntry', entry)
    }
  },
  modules: {
  }
})
